import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/bc/Cryptocurrency-Solutions.webp";
import Img02 from "../../images/services/bc/Distributed-Ledger.webp";
import Img03 from "../../images/services/bc/Decentralized-Networks.webp";
import Img04 from "../../images/services/bc/Smart-Contracts.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Consultant">
                            <h2>Partner With TekRevol—Your Blockchain App Development Consultant</h2>
                            <h5
                            className="strong">Why should you hire us for your next Blockchain mobile app?</h5>

                        </div>

                        <p>TekRevol provides Blockchain development services to Blockchain and crypto-based startups with groundbreaking solutions tailored to specific business use cases through feature integration, system modifications, and implementations.</p>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Cryptocurrency Solutions</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Decentralized Networks</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Distributed Ledger</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Smart Contracts</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;